










































































































































































































































































































































import { vxm } from '@/store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import Referrals from './Referrals.vue';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { BFormFile } from 'bootstrap-vue/es/components';
import { ResumePayload } from '../models/jobs/resumepayload';
import { JobTokenPayload } from '../models/jobs/jobTokenPayload';
import SelectOptions from './SelectOptions.vue';
import { ResumeWrapper } from '../models/jobs/resumeWrapper';
import { GenericLookup } from '../models/utility/lookup';
import { JobApplication } from '../models/jobs/jobapplication';
import Paginate from 'vuejs-paginate';
import router from '@/router';
Vue.component('paginate', Paginate);
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});
@Component({
  name: 'ResumeUpload',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
    SelectOptions,
  },
})
export default class ResumeUpload extends Vue {
  private resumePayload: ResumePayload = new ResumePayload();
  private showDetail: boolean = false;
  private supportingInfo: any;
  private questionaire: any;
  private showDefault: boolean = false;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private genericLookup: GenericLookup[] = [];
  private selectedOption: GenericLookup = new GenericLookup();
  private selectedResume: string = '';
  private defaultSelected: boolean = false;
  private applyPayload: JobApplication = new JobApplication();
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private uploadedResumeGUID: string = '';
  $wlToastr: any;
  $moment: any;
  mounted() {
    const jobid = this.$route.params.JobID;
    vxm.jobs.getAnonymousJobByID(jobid);
    vxm.jobs.getDefaultResume(vxm.users.getToken).then(() => {
      this.resumeListing = vxm.jobs.resumeListing;
      this.selectedOption.name = '';
    });
  }

  get ResumeListing(): ResumeWrapper {
    return vxm.jobs.resumeListing;
  }

  select(idx: any) {
    this.selectedOption = this.genericLookup[idx];
    this.selectProfileResume(this.selectedOption.name);
  }

  selectProfileResume(name: string) {
    this.selectedResume = name;
  }

  toggleProfileResume() {
    if (this.defaultSelected) {
      this.selectProfileResume(this.setDefault);
    } else {
      this.selectProfileResume('');
    }
  }

  getDistance(job: Job) {
    if (job.distance > 0.1) {
      return job.distance.toFixed(1);
    } else {
      return '< 0.1';
    }
  }

  getCompanyDistanceUnits(): string {
    if (vxm.jobs.getCompanyDistanceUnit == 'kilometers') {
      return 'km';
    }
    return 'mi';
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get jobDetail(): Job[] {
    const jobList: Job[] = [];
    jobList.push(vxm.jobs.AnonymousJobByID);
    return jobList;
  }

  get setDefault(): string {
    const idx = this.resumeListing.resumes.findIndex(
      (r) => r.defaultResume === true,
    );
    if (idx >= 0 && this.selectedOption.name === '') {
      return this.resumeListing.resumes[idx].name;
    } else {
      return '';
    }
  }

  clickCallback(page) {
    this.currentPage = page;
  }

  get pageCount() {
    return Math.ceil(this.genericLookup.length / this.recsPerPage);
  }

  get resumeList(): GenericLookup[] {
    const start = this.currentPage * this.recsPerPage - this.recsPerPage;
    const end = this.currentPage * this.recsPerPage - 1;
    return this.genericLookup.filter((s, idx) => {
      return idx >= start && idx <= end;
    });
  }

  selectDefault() {
    this.selectedOption = new GenericLookup();
    this.selectedOption.name = '';
    this.selectProfileResume('');
    this.genericLookup = [];
    if (this.resumeListing.resumes.length === 0) {
      this.$wlToastr('info', this.$t('ResumeDetails_NoResumeInProfile'), this.$t('MyJobListing_JobApplication'));
      return;
    }
    this.resumeListing.resumes.forEach((r) => {
      if (this.genericLookup.length < this.resumeListing.resumes.length) {
        const gLookup = new GenericLookup();
        gLookup.id = r.fileGUID;
        gLookup.name = r.name;
        gLookup.description = r.reference;
        gLookup.isSelected = r.defaultResume;
        this.genericLookup.push(gLookup);
      }
      this.$modal.show('default-resume');
    });
  }

  closeWindow() {
    this.selectedOption = new GenericLookup();
    this.selectedOption.name = '';
    this.genericLookup = [];
    this.$modal.hide('default-resume');
  }

  closeAndKeep() {
    this.$modal.hide('default-resume');
  }

  getQuestionnaire() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    vxm.jobs.getQuetionaireListing(jtp);
  }

  getSupportingInfo() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    vxm.jobs.getSupportingInfo(jtp);
  }

  uploadResume() {
    
    const vm = this;
    const token = vxm.users.getToken;
    vm.resumePayload.accessToken = token;
    vm.resumePayload.jobpostingid = parseInt(this.$route.params.JobID, 10);
    vm.resumePayload.resumelink = '';
    console.log(this.resumePayload);
    if (this.resumePayload.resume.resumename.length > 250) {
      this.$wlToastr(
        'error',
        this.$t('profile.resume.file.name.exceeded'),
        this.$t('MyJobListing_JobApplication'),
      );
      return;
    }
    const respPromise: any = vxm.jobs.postResume(this.resumePayload);
    Promise.all([respPromise]).then((values) => {
      console.log(values[0]);
      if (values[0]) {
        if (values[0].success) {
          vxm.jobs.getDefaultResume(vxm.users.getToken).then(() => {
            vm.resumeListing = vxm.jobs.resumeListing;
            vm.selectedOption.name = '';
            vm.resumePayload.resumefile = '';
            vm.selectProfileResume(this.resumePayload.resume.resumename);
            vm.uploadedResumeGUID = values[0].resumeGUID;
            vxm.users.Rudderstack.trackEvent("Resume Upload", {
        target_url: window.location.href,
              jobID: vm.resumePayload.jobpostingid,
      });
            vm.$wlToastr(
              'info',
              vm.$t('profile.upload.resume.sucess'),
              vm.$t('MyJobListing_JobApplication'),
            );
          });
        } else {
          vm.$wlToastr(
            'error',
            vm.$t('profile.upload.resume.error'),
            vm.$t('MyJobListing_JobApplication'),
          );
        }
      }
    });
  }

  chooseResume() {
    const vm = this;
    vm.applyPayload.jobPostingId = parseInt(vm.$route.params.JobID, 10);
    vm.applyPayload.companyCode = vxm.jobs.BrandingInfo.companycode;
    if (vm.selectedOption.id) {
      vm.applyPayload.resumeGUID = vm.selectedOption.id;
    } else {
      vm.applyPayload.resumeGUID = vm.uploadedResumeGUID;
    }
    const jobid = vm.$route.params.JobID;
    const job = vxm.jobs.AnonymousJobByID;
    vm.applyPayload.resumeCode = job.resumeUploadRequired;
    const respPromise: any = vxm.jobs.applyWithProfilResume(vm.applyPayload);

    Promise.all([respPromise]).then((values) => {
      if (values[0]) {
        console.log([values[0]]);
        if (values[0].nextPage === 'questionnaire') {
          const jobToken = new JobTokenPayload();
          jobToken.jobID = vm.applyPayload.jobPostingId;
          jobToken.token = vxm.users.getToken;
          vxm.jobs.getQuetionaireListing(jobToken);
        }

        if (values[0].nextPage === 'supportinginfo') {
          const jobToken = new JobTokenPayload();
          jobToken.jobID = vm.applyPayload.jobPostingId;
          jobToken.token = vxm.users.getToken;
          vxm.jobs.getSupportingInfo(jobToken);
        }

        if (values[0].nextPage === 'success') {
          vxm.jobs.setAppliedJob(jobid);
          router.push({ name: 'JobApplicationSuccess', params: { jobid } });
        }
      }
    });
  }

  setName() {
    setTimeout(() => {
      if (this.resumePayload.resumefile.name) {
        this.selectedOption = new GenericLookup();
        this.selectedOption.name = '';
        this.selectProfileResume('');
        this.genericLookup = [];
        this.resumePayload.resume.resumename = this.resumePayload.resumefile.name;
      }
    }, 50);
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }
  validateFileFormate() {
    const vm = this;
    vm.selectedResume = '';
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }
  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    // if (!allowedResumeFormat.includes(ext)) {
    //   this.$wlToastr(
    //     'error',
    //     fileNameFormat +
    //       ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
    //     'Upload Resume',
    //   );
    //   vm.resumePayload.resumefile = '';
    // }
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
}
